import { Deploy } from '@block-explorer/entities';
import { MessageData } from './types';

const prepareActionMessageData = (deploy: Deploy): MessageData => {
  const { entryPoint } = deploy;
  const entryPointName = entryPoint?.name || '';
  const actionName = {
    set_associated_keys: 'Update account',
  };

  return {
    entryPointName: entryPointName,
    actionName: actionName[entryPointName] || entryPointName,
  };
};

export const associatedKeyMessage = () => {
  const getRelevantAccountHashesFromArgs = () => {
    return [];
  };

  return {
    prepareActionMessageData,
    getRelevantAccountHashesFromArgs,
  };
};
